import { createContext, useContext } from "react";
import { SelectedTenantFieldFragment } from "graphql/generated";

export const SelectedTenantContext = createContext<SelectedTenantFieldFragment | null>(null);

export const useSelectedTenant = () => useContext(SelectedTenantContext);
